import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@deporvillage/modal-component';
import Picture from '@deporvillage/picture-component';
import { Config, I18nContext, CookieCompliance, CookieComplianceCategories, I18n } from '@deporvillage/utils-library-component';

import styles from './Usizy.module.scss';

/* eslint-disable no-undef */
/* istanbul ignore next */
global.MagicZoom = { expand: () => null };
/* eslint-enable no-undef */

const SCRIPT_URL = '//static.usizy.es/js/platform.min.js';

const UsizyClick = {
    SizeModal: 'size-modal',
    SizeWidget: 'size-widget',
};
const Usizy = ({ sku, price, url, onClick }) => {

    const ref = React.useRef(null);
    const [showModal, setShowModal] = React.useState(false);
    const [isInit, setIsInit] = React.useState(false);
    const [canRun, setCanRun] = React.useState(false);
    const { translate } = React.useContext(I18nContext);
    const { lang } = React.useContext(Config);

    const handleInit = (canRun) => {
        if (!ref.current) return;
        setIsInit(true);
        setCanRun(canRun);
    }

    const showSizeGuide = (event) => {
        if (event.data.subject === 'START_APP') onClick && onClick(UsizyClick.SizeWidget);
        else if (event.data.event === 'GUIDE') openModal();
    };

    const openModal = () => {
        setShowModal(true);
        onClick && onClick(UsizyClick.SizeModal);
    };

    //TODO - try to get rid of memory leak warning
    React.useEffect(() => {
         CookieCompliance(handleInit, CookieComplianceCategories.Functional);
    }, []);

    React.useEffect(() => {
        if (!canRun) return;
        /* eslint-disable-next-line no-undef */
        let script = document.createElement("script");
        script.src = SCRIPT_URL;
        script.async = true;
        script.priority = 'low';
        ref.current.appendChild(script);
        /* eslint-disable-next-line no-undef */
        window.addEventListener('message', showSizeGuide);
        return () => {
            /* eslint-disable-next-line no-undef */
            window.removeEventListener('message', showSizeGuide);
        };
    }, [canRun]);

    return (
        <div className={styles['usizy-component']} ref={ref}>
            {
                isInit ? (
                    <>
                        {
                            canRun ? (
                                <div className={'usizy-external'}
                                    data-layout="inline"
                                    data-text={translate('product_page.sizing.size_guide')}
                                    data-product={sku}
                                    data-language={lang}
                                    data-price={price}
                                />
                            ) : (
                                <div className={styles['usizy-disabled']} onClick={openModal}>
                                    <a>
                                        <I18n>product_page.sizing.size_guide</I18n>
                                    </a>
                                </div>
                            )
                        }
                    </>
                ) : (
                    null
                )
            }

            {
                showModal && (
                    <Modal onClose={() => setShowModal(false)}>
                        <div className={styles['size-guide-wrapper']}>
                            <Picture src={`product/${url}`} name={sku} lazy />
                        </div>
                    </Modal>
                )
            }
        </div>
    );
};

Usizy.propTypes = {
    sku: PropTypes.string,
    price: PropTypes.number,
    url: PropTypes.string,
    onClick: PropTypes.func,
};

export default Usizy;
export { UsizyClick };
